export default __webpack_public_path__ + "static/go-creative-show-89de0a20a3ad1a9441207e4bf5682779.png";